const initFormFieldsToggle = () => {
    const contactForm = document.querySelector("#contactform");
    if (contactForm) {
        const machineSelect = contactForm.querySelector("#contactform-machine");
        const elementsToBeToggledArray = document.querySelectorAll("[data-form-toggle-type]");
        //give it a first run to show correct data only
        toggleFormFields(elementsToBeToggledArray, machineSelect);
        machineSelect.addEventListener("change", () => {
            toggleFormFields(elementsToBeToggledArray, machineSelect);
        });
    }
};
//IF YOU WANT TO INSERT A NEW "data-form-toggle-type", THIS CODE HANDLES ONLY SINGLE WORDS
//SO MAKE THE VALUE OF THE OPTION AND THE ATTR BE JUST ONE WORD
//EXAMPLE: NEWTYPE IS OK, NEW-TYPE WILL CAUSE ERRORS
//IF YOU WANT AN ELEMENT TO BE AVAILABLE FOR MORE THAN ONE TYPE OF OPTION
//THEN SEPARE THE TYPES WITH ";" LIKE THIS "data-form-toggle-type="filling;processing"
const toggleFormFields = (array, selectToggler) => {
    array.forEach((element) => {
        if (element.getAttribute("data-form-toggle-type").split(";").includes(selectToggler.value.toLowerCase())) {
            element.classList.remove("hidden");
            if (element instanceof HTMLInputElement || element instanceof HTMLSelectElement) {
                element.removeAttribute('disabled');
            }
            else {
                element.querySelectorAll("input, select").forEach((input) => {
                    input.removeAttribute('disabled');
                });
            }
        }
        else {
            element.classList.add("hidden");
            if (element instanceof HTMLInputElement || element instanceof HTMLSelectElement) {
                element.disabled = true;
            }
            else {
                element.querySelectorAll("input, select").forEach((input) => {
                    input.disabled = true;
                });
            }
        }
    });
};
